export interface ISQLTableData {
  tableName: string;
}

export interface ISQLIndexSeeder {
  matchingTableNames: string[];
  sqlCommands: string[];
}
